import PropTypes from 'prop-types';
import React, {Component} from 'react';
import DashboardApi from '../../../../api/dashboard.jsx';
import Loader from '../../loader.jsx';
import BarChart  from '../../charts/BarChart.jsx';
import BioguardProductSales from './bioguardProductSales.jsx';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {makeCancelable} from 'helpers/cancelablePromise';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

const barColors = ['#9B6BBF', '#E97537', '#93CB4D', '#33B2E5', '#C94D6B', '#57D6DC', '#AFC6DC', '#8DC1D4', '#F7D870'];
const defaultGrahpPixelsXIndentation = 82;

class BioguardTotalSales extends Component {
  static propTypes = {
    branch: PropTypes.any,
    branches: PropTypes.array,
    end: PropTypes.any,
    intl: intlShape.isRequired,
    start: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      report: null,
      loaded: false,
      selectedCategoryReport: null,
      selectedBarXPosition: 0,
    };
  }

  componentDidMount() {
    this.onUpdate();
  }

  componentWillUpdate(nextProps) {
    if (nextProps.branch !== this.props.branch ||
            nextProps.branches !== this.props.branches ||
            nextProps.start !== this.props.start ||
            nextProps.end !== this.props.end
        ) {
      this.onUpdate(nextProps);
    }
  }

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  onUpdate(props = this.props) {
    const {branch, branches, start, end} = props;

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.getBioGuardTotalSales(branch === -1 ? branches : branch,
            start, end)))
      .then(data => {
        this.setState({
          report: data,
          selectedCategoryReport: data && data.length > 0 ? Object.assign({},data[0],{color: barColors[0]}) : null,
          loaded: true,
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          loaded: false,
        });
      });
  }

  changeProductReport = e => {
    if(e && e.item && e.item.dataContext) {
      let arrowPosition = e.item.x + defaultGrahpPixelsXIndentation;

      this.setState({
        selectedCategoryReport: e.item.dataContext,
        selectedBarXPosition: arrowPosition,
      });
    }
  };

  renderedGraphFirstTime = e => {
    if(e && e.chart && e.chart.chartData && e.chart.chartData[0]) {
      let arrowPosition = e.chart.chartData[0].x.categoryAxis + defaultGrahpPixelsXIndentation;

      this.setState({
        selectedBarXPosition: arrowPosition,
      });
    }

  };

  render() {
    const {report, loaded, selectedCategoryReport, selectedBarXPosition} = this.state;
    const listeners = [
      {
        'event': 'clickGraphItem',
        'method': this.changeProductReport,
      },{
        'event': 'init',
        'method': this.renderedGraphFirstTime,
      },

    ];

    return (
      <div className='total-sales-report expanded-tile'>
        { report ?
          <Loader loaded={loaded}>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='report-header'>
                  <h2 className='title'><FormattedMessage id="general.total.bioguard.sales" /></h2>
                  <hr/>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12'>
                { report.length > 0 ?
                  <div className="report-graph">
                    <BarChart data={this.state.report} verticalAxisTitle={this.props.intl.formatMessage({id: 'general.sales'}) + ' ($)'}
                                    colors={barColors}
                                    titleField='categoryName'
                                    valueField='totalCategorySalesAmount'
                                    balloonText={'[[title]] ' + this.props.intl.formatMessage({id: 'general.sales'}) + ': <b>$[[value]]</b>'}
                                    fillAlphas={0.75}
                                    fixedColumnWidth={50}
                                    listeners={listeners}
                                    precision={2}
                                />
                  </div> :
                  <p><FormattedMessage id="posdashboard.error.no.data" /></p>
                        }
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-12'>
                {selectedCategoryReport ?
                  <BioguardProductSales
                                    categoryName={selectedCategoryReport.categoryName}
                                    baseColor = {selectedCategoryReport.color}
                                    totalProductSalesAmount={selectedCategoryReport.totalCategorySalesAmount}
                                    productSalesDetails={selectedCategoryReport.productSalesDetail}
                                    positionArrow={selectedBarXPosition}/> :
                  <div/>}
              </div>
            </div>
          </Loader> :
          <div/>}
      </div>
    );
  }
}

export default injectIntl(bindLocaleUpdate(BioguardTotalSales));
